import type { AxiosRequestConfig } from "axios";

import { httpAuth } from "../utils/axios.js";
import { getGroupAuthType } from "@/redux/actions/auth.js";
import { GROUP_AUTH_HEADER_NAME } from "@/constants/axios.js";
import type { PatientConsent } from "@/core/types/consent.js";
import type { UUID } from "@/core/types/common.js";

export const providerRequestsTyped = {
  get_patient_consents: function ({
    patientId,
    params,
  }: {
    patientId: UUID;
    params?: Record<string, unknown>;
  }) {
    const config = {
      method: "post",
      url: `/v1/patient_management/${patientId}/get_latest_consents`,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      params,
    } satisfies AxiosRequestConfig;
    return httpAuth(config) as unknown as Promise<PatientConsent[]>;
  },
};
